import Button from '../../../../UI/Button/Button'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import useToast, { Type } from '../../../../hooks/useToast'
import { frontendDomain } from '../../../../../utility'

type Props = {
  uuid: string
}

const CopyPublicLink: React.FC<Props> = ({ uuid }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const toast = useToast()
  const value = `${frontendDomain}/public/survey/${uuid}`

  const copyValue = () => {
    navigator.clipboard.writeText(value)
    toast(t.survey.configuration.copyPublicLink, Type.SUCCESS)
  }

  return <Button className="font-bold text-lg w-full" onClick={copyValue} contrast text={t.survey.configuration.copyPublicLink} />
}

export default CopyPublicLink
